import React from 'react';
import PropTypes from 'prop-types';
import BaseIcon from 'assets/icons/BaseIcon';

class ChevronDown extends BaseIcon {
    render() {
        const {
            height,
            width,
            style,
        } = this.props;

        return (
            <svg
                height={ height }
                viewBox='0 0 515.556 515.556'
                width={ width }
                style={ style }
                xmlns='http://www.w3.org/2000/svg'
            >
                <path d='M257.778 386.671L0 128.893h128.886l128.892 128.889 128.886-128.897 128.892.008z'/>
            </svg>
        );
    }
}

ChevronDown.defaultProps = {
    height: '512',
    width: '512',
};

ChevronDown.propTypes = {
    height: PropTypes.string,
    width: PropTypes.string,
    style: PropTypes.object,
};

export default ChevronDown;



// WEBPACK FOOTER //
// ./src/assets/icons/ChevronDown.js